var mapConfig = {
  mapId : 'site-switcher',
  tileLayers : {
    mapbox: {
      name: 'mapbox',
      url: 'https://api.mapbox.com/v4/{user}.{mapId}/{z}/{x}/{y}.png?access_token={token}',
      type: 'xyz',
      layerOptions: {
        mapId: 'satellite',
        user: 'mapbox',
        token: 'pk.eyJ1Ijoic2t5Y2F0Y2gtZGV2IiwiYSI6Ik1PVjVYNEkifQ.j2X9OOZDz7ABqUvHk4kesw',
      }
    },
    tileLayer: {
      name: 'tileLayer',
      url: 'https://{s}-tiles.skycatch.com/{layerId}/{z}/{x}/{y}.png',
      type: 'xyz'
    }
  },
  // mapCenter : defaultLocation,
  mapDefaults : {
    attributionControl: false,
    controls : {
      layers : {
        visible : false
      }
    },
    detectRetina: false,

    dragging: true,

    // disable zoom
    boxZoom: false,
    keyboard: false,
    doubleClickZoom: false,
    touchZoom: false,
    scrollWheelZoom: false,
    zoomControl: false,
  },
  events : {
    map: {
      logic: 'emit',
      enable: []
    },
    marker: {
      logic: 'emit',
      enable: []
    },
    path: {
      logic: 'emit',
      enable: [],
    }
  }
}

module.exports = mapConfig;


// WEBPACK FOOTER //
// ./src/app/dash/siteSelector/PreviewMapConfig.js